export function ArrowRightV1(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" {...props}>
      <rect
        width="36"
        height="36"
        fill={props.bgColor || '#fff'}
        opacity={typeof props.bgOpacity === 'number' ? props.bgOpacity : 0.4}
        rx="18"
        transform="matrix(-1 0 0 1 36 0)"
      ></rect>
      <g clipPath="url(#clip0_112_2612)">
        <path
          stroke={props.arrowColor || '#fff'}
          strokeWidth="1.5"
          d="M15.578 11.828l5.819 5.818-5.819 5.819"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_112_2612">
          <rect
            width="20.571"
            height="20.571"
            fill="#fff"
            rx="10.286"
            transform="matrix(0 1 1 0 7.7 7.713)"
          ></rect>
        </clipPath>
      </defs>
    </svg>
  );
}

export function ArrowLeftV1(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" {...props}>
      <rect
        width="36"
        height="36"
        fill={props.bgColor || '#fff'}
        opacity={typeof props.bgOpacity === 'number' ? props.bgOpacity : 0.4}
        rx="18"
      ></rect>
      <g clipPath="url(#clip0_112_2596)">
        <path
          stroke={props.arrowColor || '#fff'}
          strokeWidth="1.5"
          d="M20.422 11.828l-5.819 5.818 5.819 5.819"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_112_2596">
          <rect
            width="20.571"
            height="20.571"
            x="28.301"
            y="7.713"
            fill="#fff"
            rx="10.286"
            transform="rotate(90 28.3 7.713)"
          ></rect>
        </clipPath>
      </defs>
    </svg>
  );
}

export function ArrowRightV2(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="24"
      fill="none"
      viewBox="0 0 36 24"
      {...props}
    >
      <rect
        width="36"
        height="24"
        fill="#fff"
        opacity="0.2"
        rx="12"
        transform="matrix(-1 0 0 1 36 0)"
      ></rect>
      <path
        fill="#D9D9D9"
        d="M19.417 16.333L24 11.667l-4.583 4.666zM24 11.667L19.417 7 24 11.667zm0 0H13h11z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M19.417 16.333L24 11.667m0 0L19.417 7M24 11.667H13"
      ></path>
    </svg>
  );
}

export function ArrowLeftV2(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="24"
      fill="none"
      viewBox="0 0 36 24"
      {...props}
    >
      <rect width="36" height="24" fill="#fff" opacity="0.2" rx="12"></rect>
      <path
        fill="#D9D9D9"
        d="M16.583 16.333L12 11.667l4.583 4.666zM12 11.667L16.583 7 12 11.667zm0 0h11-11z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16.583 16.333L12 11.667m0 0L16.583 7M12 11.667h11"
      ></path>
    </svg>
  );
}

export function ArrowLeftV3(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
      <g filter="url(#filter0_d_255_271)">
        <g filter="url(#filter1_d_255_271)">
          <rect x="7" y="5" width="36" height="36" rx="18" fill="white" />
        </g>
        <g clip-path="url(#clip0_255_271)">
          <path d="M27.4159 16.83L21.5974 22.6484L27.4159 28.4669" stroke="#111C36" stroke-width="2" />
        </g>
      </g>
      <defs>
        <filter id="filter0_d_255_271" x="0" y="0" width="50" height="50" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_255_271" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_255_271" result="shape" />
        </filter>
        <filter id="filter1_d_255_271" x="5.5" y="3.5" width="39" height="39" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="0.75" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0666667 0 0 0 0 0.109804 0 0 0 0 0.211765 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_255_271" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_255_271" result="shape" />
        </filter>
        <clipPath id="clip0_255_271">
          <rect x="35.2891" y="12.7168" width="20.5714" height="20.5714" rx="10.2857" transform="rotate(90 35.2891 12.7168)" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
